import Delivery from '@/service/delivery'
import RequestUtils from './requestUtils.js'
import { Message } from 'element-ui'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getdeliveryaddresses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Delivery.getdeliveryaddresses(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getdeliveryaddress(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Delivery.getdeliveryaddress(payload), {
        type: 'info',
        success,
        fail
      })
    },
    adddeliveryaddress(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Delivery.adddeliveryaddress(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatedeliveryaddress(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Delivery.updatedeliveryaddress(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletedeliveryaddress(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Delivery.deletedeliveryaddress(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getprovinces(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Delivery.getprovinces(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getcitys(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Delivery.getcitys(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getareas(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Delivery.getareas(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getcitytree(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Delivery.getcitytree(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getAreaAll(context, { payload, success, fail }) {
      Promise.all([
        Delivery.getprovinces({
          pageNum: 1,
          pageSize: 10000
        }),
        Delivery.getcitys({
          pageNum: 1,
          pageSize: 10000,
          provinceCode: payload.provinceCode
        }),
        Delivery.getareas({
          pageNum: 1,
          pageSize: 10000,
          cityCode: payload.cityCode
        })
      ])
        .then(([province, city, area]) => {
          console.log(province, city, area)
          province.data.records.forEach(item => {
            item.value = item.provinceCode
            item.label = item.provinceName
            item.children = []
          })
          const options = province.data.records
          city.data.records.forEach(item => {
            item.value = item.cityCode
            item.label = item.cityName
            item.children = []
          })
          const index = options.findIndex(i => i.value === payload.provinceCode)
          options[index].children = city.data.records

          area.data.records.forEach(item => {
            item.value = item.areaCode
            item.label = item.areaName
          })
          const cIndex = options[index].children.findIndex(
            i => i.value === payload.cityCode
          )
          options[index].children[cIndex].children = area.data.records
          success && success(options)
        })
        .catch(err => {
          Message.error(err.message)
          fail && fail(err)
        })
    }
  }
}
